var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"bg-gray-200"},[_c('NavigationMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }